// extracted by mini-css-extract-plugin
export var ExternalLink = "media-kit-module--ExternalLink--3d5df";
export var ExternalLinkImageWrapper = "media-kit-module--ExternalLinkImageWrapper--04132";
export var SideColumnText = "media-kit-module--SideColumnText--825f8";
export var SideColumnTitle = "media-kit-module--SideColumnTitle--874b7";
export var content = "media-kit-module--content--3f45f";